const lifestyleType = {
  displayField: 'header',
  name: 'Lifestyle Type',
  description: 'For use on Shops Homepage',
  fields: [
    {
      id: 'header',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'type',
      name: 'Type',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Symbol',
        validations: [
          {
            in: [
              'Water',
              'Golf',
              'Mountain',
              'Wine',
              'Ranch',
              'Ski',
              'Equestrian'
            ]
          }
        ]
      }
    },
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'slug',
      name: 'slug',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    }
  ],
  sys: {
    id: 'lifestyleType',
    version: 7,
    updatedAt: '2023-08-01T21:37:22.544Z'
  }
};
export default lifestyleType;